import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { familyMessages } from 'pages/admin/cadastros/produto/familia/variables/familyMessages';
import { deleteFamily } from 'services/api/requests/requests';
import { mapErrorToToastProps } from 'utils/forms/mapErrorToToastProps';

export const useDeleteFamily = () => {
	const queryClient = useQueryClient();
	const toast = useToast();

	return useMutation(deleteFamily, {
		onSuccess: () => {
			queryClient.invalidateQueries(['family-list']);
			queryClient.invalidateQueries(['productNotFamily-list']);
			queryClient.invalidateQueries(['family-list-with-products']);

			toast({
				title: familyMessages.MSG_FAMILY_DELETED_SUCCESS,
				description: familyMessages.MSG_FAMILY_DELETED_SUCCESS,
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});
		},
		onError: (error: any) => {
			const toastErrors: Array<any> = mapErrorToToastProps(
				error,
				familyMessages.MSG_FAMILY_DELETE_ERROR
			);
			toastErrors?.forEach(element => toast(element));
		},
	});
};
